import { Pipe, PipeTransform, } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { enContent} from './i18n/en';
import { tcContent} from './i18n/tc';
import { scContent} from './i18n/sc';

@Pipe({
    name: 'i18n',
})

export class i18nPipe implements PipeTransform {
    
    language;
    webContent;
    constructor(
        public _activatedRoute: ActivatedRoute
    ){
        this._activatedRoute.queryParams.subscribe(params => {
            if(params['lang']){
                this.language = params['lang'];
            }else{
                this.language = 'en_US'
            }
        })
    }
    transform(value: string, externalApiErrId:any = '', language: any = 'en_US') {
        //lang (“zh_Hant” / “zh_Hans” / “en_US” , default en_US)

        switch (this.language) {
            case 'zh_Hant': {
                this.webContent = tcContent;
                break;
            }
            case 'zh_Hans': {
                this.webContent = scContent;
                break;
            }
            default: {
                this.webContent = enContent;
                break;
            }
        }

        let returnStr = this.webContent[value];
        if(externalApiErrId){
            returnStr += "(" + externalApiErrId + ")";
        }
        return returnStr;
        
    }
    
}